import { Injectable } from '@angular/core';
import { AccuserAppealModel } from '../../view-models/appeal-judgement';
import { AccuserModel } from '../../view-models/conferencing';
import { Mapper } from '../mapper';
import { AppealJudgementAccuserDetailMapper } from './appeal-accuser.-detailmapper';

@Injectable({
    providedIn: 'root'
})
export class AppealJudgementAccuserMapper implements Mapper<AccuserAppealModel, AccuserModel>  {
    constructor(
        private appealJudgementAccuserDetailMapper:AppealJudgementAccuserDetailMapper
    ) { }
    mapForm(param: AccuserAppealModel): AccuserModel {
        const data = new AccuserModel
        data.items = param.filingAs.map(x=>this.appealJudgementAccuserDetailMapper.mapTo(x))
        return data!
    }

    mapTo(param: AccuserModel): AccuserAppealModel {
        return null!
    }

} 